export default {
  'positions.title': 'Manage Positions',
};
